import React from 'react';
import { useNavigate } from 'react-router-dom';

const BLOGS = [
  {
    slug: 'how-to-describe-features',
    title: 'How to Describe Features Using Vibe Coding Prompts (2025)',
    excerpt: 'A practical formula and real examples for writing prompts that reliably ship features.',
    image: '/lovablelogo.png'
  },
  {
    slug: 'best-vibe-coding-tools-2025',
    title: 'Best Vibe Coding Tools in 2025 — Tested and Ranked',
    excerpt: 'Hands-on comparison across builders: what to use and when.',
    image: '/Screenshot 2025-10-28 at 21.18.54.png'
  },
  {
    slug: 'prompting-for-vibe-coding-guide',
    title: 'Prompting for Vibe Coding: A Friendly Guide (with Templates)',
    excerpt: 'A step-by-step guide and templates for prompts that build apps cleanly.',
    image: '/valycodelogo.png'
  },
  {
    slug: 'how-to-build-effective-app-prompts',
    title: 'How to Build Effective App Building Prompts?',
    excerpt: 'Seven keys (D2D) to prompts that deliver with AI app builders.',
    image: '/Screenshot 2025-11-01 at 16.30.49.png'
  },
  {
    slug: 'build-mobile-app-claude-code',
    title: 'How I Built a Full Mobile App in 2 Hours with Claude Code',
    excerpt: 'A practical guide to shipping mobile apps faster with AI-powered coding.',
    image: '/claudecode.png'
  },
  {
    slug: 'claude-code-opus-4-7-2026',
    title: 'How to Build Apps with Claude Code (Opus 4.7) in 2026',
    excerpt: 'The setup, prompts, and workflow that separate weekend builds from broken toys.',
    image: '/aitoolslogos/claude-ai.png'
  }
];

const BlogSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">From the blog</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {BLOGS.map((b) => (
            <button
              key={b.slug}
              onClick={() => navigate(`/blog/${b.slug}`)}
              className="text-left group rounded-2xl border border-gray-200 bg-white/80 backdrop-blur-sm shadow-sm overflow-hidden hover:shadow-md transition-all"
            >
              <div className="aspect-[16/9] bg-gray-100 overflow-hidden">
                <img
                  src={b.image}
                  alt={b.title}
                  className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <h3 className="text-lg font-semibold text-gray-900 mb-2 leading-snug">{b.title}</h3>
                <p className="text-gray-600 text-sm">{b.excerpt}</p>
                <div className="mt-4 text-sm font-medium text-black inline-flex items-center gap-1">
                  Read more <span>→</span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;



